export const refs = {
  headerForm: document.querySelector('.header-form'),
  tasksList: document.querySelector('.tasks-list'),
};
